export default __webpack_public_path__ + "static/media/logo.ec75d839.png";